import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import NavigationAppShell from '../../common/navigation-app-shell'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import * as pageTextActions from '../../store/page-texts'
import * as emailActions from '../../store/email'
import ReactMarkdown from 'react-markdown'
import Styles from '../../common/styles'
import Y from '../../y18n'

const mapStateToProps = state => ({
  pageTexts: state.pageTexts,
  locales: state.locales,
  accounts: state.accounts,
  email: state.email
})

const mapDispatchToProps = dispatch => ({
  pageTextActions: bindActionCreators(pageTextActions, dispatch),
  emailActions: bindActionCreators(emailActions, dispatch)
})

class SupportPage extends Component {
  state = {
    email: '',
    disabled: true
  }

  componentDidMount () {
    this.props.pageTextActions.getPageText('SupportPage', this.props.locales.country, this.props.locales.language)
  }

  componentWillUnmount () {
    this.setState({ email: '', disabled: true })
    this.props.emailActions.resetStatus()
  }

  goToContactForm () {
    this.props.history.push('/contact-us')
  }

  inputChanged = name => event => {
    this.setState({ [name]: event.target.value, disabled: event.target.value.length <= 0 })
  }

  submitCheckEmail = e => {
    e.preventDefault()
    this.setState({ disabled: true })
    this.props.emailActions.checkEmailStatus(this.state.email)
  }

  unblockEmail = email => {
    this.props.emailActions.unblockEmail(email)
  }

  render () {
    const { accounts, classes } = this.props
    return accounts.isAuthenticated
      ? <NavigationAppShell content={this.renderSupportContent()} pageName={'Support'} />
      : <TopNavigationAppShell
        content={<div className={classes.topNavContent}>{this.renderSupportContent()}</div>}
        pageName={'Support'}
        startPage={false}
        />
  }

  renderSupportContent () {
    const { pageTexts, email, classes, accounts } = this.props
    const topMargin = accounts.isAuthenticated ? '0px' : '20px'
    return (
      <Paper style={{ marginTop: topMargin }}>
        {(pageTexts.loading || email.loading) && <LinearProgress />}
        <div className={classes.content}>
          <ReactMarkdown source={pageTexts.item.content} escapeHtml={false} />
          <hr />
          <form onSubmit={e => this.submitCheckEmail(e)} style={{ marginBottom: '80px', marginTop: '40px' }}>
            <Typography variant='title'>
              {Y`Check if Email is blocked`}
            </Typography>
            <TextField
              margin='normal'
              label={Y`Email address to check`}
              type='email'
              value={this.state.email}
              onChange={this.inputChanged('email')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              style={{ maxWidth: '400px', width: '100%', marginTop: '40px' }}
            />
            <Button
              type='submit'
              variant='raised'
              style={{ padding: '10px 16px', marginTop: '10px', marginBottom: '20px', display: 'block' }}
              disabled={this.state.disabled}
            >
              {Y`Check`}
            </Button>
            {email.emailStatus !== null &&
              !email.emailStatus &&
              <div>
                <Typography variant='subheading'>
                  <span style={{ color: 'red' }}>
                    {email.unblockStatus === null &&
                      Y`The email is blocked. You have probably by mistake managed to block the camera's sender as spam.`}
                  </span>
                  <br />
                  <span className={classes.themeLink} onClick={() => this.unblockEmail(this.state.email)}>
                    {email.unblockStatus === null && Y`Click here to remove the block`}
                  </span>
                  <span style={{ color: 'forestgreen' }}>
                    {email.unblockStatus !== null && Y`Email is no longer blocked`}
                  </span>
                </Typography>
              </div>}
            {email.emailStatus !== null &&
              email.emailStatus &&
              <div>
                <Typography variant='subheading'>
                  <span style={{ color: 'forestgreen' }}>
                    {Y`Email is not blocked. Please check your junk mail folder or double check that you filled in the correct Email in the camera if you don't receive any emails`}
                  </span>
                </Typography>
              </div>}
          </form>
          {/*  Quickfix for Zendesk mail form */}
          <div className={classes.buttonRow}>
            {this.props.locales.country != 'Sweden' ? (
              <Button
                variant='raised'
                color='primary'
                style={{ color: '#fff', textDecoration: 'none' }}
                onClick={() => this.goToContactForm()}>
                {Y`Go to the contact form`}
              </Button>
            ):(
              <Button
                variant='raised'
                color='primary'
                style={{ color: '#fff', textDecoration: 'none' }}
                component={props => <a href={`mailto:support@hyltesim.se?subject=Fråga om HylteSIM&body=Om du har ett konto på HylteSIM så var vänlig och ange den mailadress du använder:%0D%0A${this.props.accounts.profile.email || ''}%0D%0A%0D%0AOm du har ett aktivt abonnemang och din fråga rör just detta abonnemang, fyll då i ditt IMSI nummer (det räcker med de 6 sista sifforna):%0D%0A%0D%0A%0D%0ABeskriv utförligt vad du behöver hjälp med:%0D%0A%0D%0A%0D%0A`} {...props}/>}>
                {Y`Go to the contact form`}
              </Button>
            )
            }
          </div>
        </div>
      </Paper>
    )
  }
}

SupportPage = connect(mapStateToProps, mapDispatchToProps)(SupportPage)
export default withStyles(Styles)(SupportPage)



// WEBPACK FOOTER //
// ./src/pages/support/index.js